import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.styl';
import cn from 'classnames/bind';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';
import { IconFunnel } from '@consta/uikit/IconFunnel';
import { ContextMenu } from '@consta/uikit/ContextMenu';
import AnalyticsAnswersInfoCart from 'src/components/AnalyticsAnswersInfoCart';
import { Pagination } from '@consta/uikit/Pagination';
import { useSelector } from 'react-redux';
import { analyticSelector } from 'src/redux/features/analytic/selectors';
import { QuestionTypeEnum } from 'src/utils/enum';
import { ISummaryTableItem } from 'src/redux/features/analytic/types';
import { hotKeys } from 'src/config/config';

export interface IAnalyticsResultTableProps {}

const cx = cn.bind(styles);
const ITEMS_PER_PAGE = 10;

interface IFilterItems {
  name: string;
  action: () => void;
}

const AnalyticsResultTable: React.FC<IAnalyticsResultTableProps> = () => {
  const ref = useRef();
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [currentFilter, setCurrentFilter] = useState<QuestionTypeEnum | null>(
    null,
  );
  const [currentPage, setCurrentPage] = useState<number>(0);

  const summaryTable = useSelector(analyticSelector).summaryTable;
  const [items, setItems] = useState<Array<ISummaryTableItem>>(summaryTable);
  const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);

  useEffect(() => {
    if (currentFilter === null) {
      return setItems(summaryTable);
    }
    return setItems(summaryTable.filter((item) => item.type === currentFilter));
  }, [currentFilter, summaryTable]);

  const filterItems: IFilterItems[] = [
    {
      name: 'Ответ от пользователя',
      action: () => setCurrentFilter(QuestionTypeEnum.SELF_SELECT),
    },
    {
      name: 'Одиночный выбор',
      action: () => setCurrentFilter(QuestionTypeEnum.SINGLE_SELECT),
    },
    {
      name: 'Одиночный выбор + свой вариант',
      action: () => setCurrentFilter(QuestionTypeEnum.SINGLE_AND_SELF),
    },
    {
      name: 'Множественный выбор',
      action: () => setCurrentFilter(QuestionTypeEnum.MULTIPLE_SELECT),
    },
    {
      name: 'Множественный выбор + свой вариант',
      action: () => setCurrentFilter(QuestionTypeEnum.MULTIPLE_AND_SELF),
    },
    {
      name: 'Балльная оценка',
      action: () => setCurrentFilter(QuestionTypeEnum.POINT_RATING),
    },
    {
      name: 'Множественная балльная оценка',
      action: () => setCurrentFilter(QuestionTypeEnum.MULTIPLE_POINT_RATING),
    },
  ];

  const handleChange = (pageNumber: number): void => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className={cx('AnalyticsResultTable__sortContainer')}>
        <Text size="s">Фильтровать по:</Text>
        <div className={cx('AnalyticsResultTable__sort')}>
          <div className={cx('AnalyticsResultTable__sortItem')}>
            <Text weight="bold" size="xs">
              Тип вопроса
            </Text>
            <Button
              onlyIcon
              iconLeft={IconFunnel}
              view="clear"
              ref={ref}
              onClick={() => setIsOpenFilter(true)}
              size="s"
            />
            {isOpenFilter && (
              <ContextMenu
                anchorRef={ref}
                items={filterItems}
                direction="downStartLeft"
                getLabel={(item) => item.name}
                onClickOutside={() => setIsOpenFilter(false)}
                getOnClick={(item) => {
                  setIsOpenFilter(false);
                  return item.action;
                }}
              />
            )}
          </div>
        </div>
      </div>
      {currentFilter !== null && (
        <div className={cx('AnalyticsResultTable__sortReset')}>
          <Text>
            Найдено {items?.length} из {summaryTable?.length} значений
          </Text>
          <Text
            onClick={() => setCurrentFilter(null)}
            view="link"
            cursor="pointer"
          >
            Сбросить фильтр
          </Text>
        </div>
      )}
      {items
        ?.slice(
          currentPage * ITEMS_PER_PAGE,
          currentPage * ITEMS_PER_PAGE + ITEMS_PER_PAGE,
        )
        .map((value, index) => (
          <AnalyticsAnswersInfoCart
            question={value}
            key={index}
            number={currentPage * ITEMS_PER_PAGE + index + 1}
          />
        ))}
      <div className={cx('AnalyticsResultTable__pagination')}>
        <Pagination
          currentPage={currentPage}
          onChange={handleChange}
          totalPages={totalPages}
          hotkeys={hotKeys}
        />
      </div>
    </div>
  );
};

export default AnalyticsResultTable;
